import React from "react";
import "../styles/Videos.css";
import { useNavigate } from "react-router-dom";
import menu_dots from "../images/menu_dots.png";
import anavuLogo from "../images/anavu_logo.svg";
import { anavuViewsIncrement } from "../Services/AllServices";

const formatUploadDate = (uploadDate) => {
  const now = new Date();
  const uploadTime = new Date(uploadDate);
  const timeDifference = now - uploadTime;

  const seconds = Math.floor(timeDifference / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return `${days} day${days > 1 ? "s" : ""} ago`;
  } else if (hours > 0) {
    return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  } else if (minutes > 0) {
    return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
  } else {
    return "Just now";
  }
};

const incrementAnavuViews = async (videoId) => {
  try {
    const formData = { video_id: videoId };
    await anavuViewsIncrement(formData, (response) => {
      if (response && response.status === "success") {
        console.log("Views Incremented Successfully from videosjs:", response);
      } else {
        console.log("Views Increment Failed:", response);
      }
    });
  } catch (error) {
    console.error("Error in incrementAnavuViews:", error);
  }
};

const Videos = ({ videoData = [] }) => {
  const navigate = useNavigate();

  const sortedVideos = videoData.sort(
    (a, b) => new Date(b.upload_date) - new Date(a.upload_date)
  );

  const handleVideoClick = async (video) => {
    await incrementAnavuViews(video._id);
    console.log("navigatignt to videoplayer"); // Ensure incrementAnavuViews is awaited
    navigate("/videoplayer", { state: { video, videoData } });
  };

  return (
    <div className="video_container">
      <div className="videos">
        {sortedVideos.length > 0 ? (
          sortedVideos.map((video, index) => (
            <div
              className="video-item"
              key={index}
              onClick={() => handleVideoClick(video)}
            >
              <div className="video-thumbnail">
                <img
                  src={video?.thumbnail?.url || "default-thumbnail.png"}
                  alt={`Thumbnail for ${video.title} is not available`}
                />
              </div>
              <div className="video-info">
                <div className="video-left">
                  <div className="channel-logo">
                    <img src={video.channelLogo || anavuLogo} alt="channel logo" />
                  </div>
                </div>
                <div className="video-middle">
                  <h4 className="video-title">{video.title}</h4>
                  <div className="video-title-tooltip">{video.title}</div>
                  <div className="video-channel">{video.creatorName}</div>
                  <div className="video-details">
                    <div className="video-views">{video.views} views</div>
                    <div className="small-dot"></div>
                    <div className="learner-video-time">
                      {formatUploadDate(video.upload_date)}
                    </div>
                  </div>
                </div>
                <div className="video-right">
                  <img src={menu_dots} alt="Menu dots" className="menu-dots" />
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-videos-message">No videos created yet.</div>
        )}
      </div>
    </div>
  );
};

export default Videos;
